<template>
  <div class="" testek="product-detail">
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleOrderId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">
          {{ title }}
        </div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item
                  prop="id"
                  testek="id"
                  class="w-full flex-1"
                  labelAlign="left"
                >
                  <div class="mr-8 flex">
                    <div class="flex min-w-40 font-bold">
                      ID
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.id" />
                  </div>
                </a-form-item>
                <div class="flex flex-1">
                  <div class="flex-1 font-bold text-xl">
                    {{ $t("i18nCommon.TotalAmount") }}
                  </div>
                  <div class="flex-1 font-bold text-xl">
                    {{ $filters.formatMoney(TotalAmount) }}
                    <span class="ml-2">VND</span>
                  </div>
                </div>
              </div>
              <a-form-item>
                <div>
                  <a-button class="editable-add-btn mb-2" @click="handleAddRow">{{
                    $t("i18nCommon.AddRow")
                  }}</a-button>
                  <div class="table-items">
                    <a-table
                      bordered
                      :data-source="dataSource"
                      :columns="columns"
                      :pagination="false"
                      :scroll="{ y: '250px' }"
                    >
                      <template #product="{ record }">
                        <div class="editable-cell">
                          <div
                            v-if="editableData[record.key]"
                            class="editable-cell-input-wrapper"
                          >
                            <a-select
                              testek="combobox"
                              v-model:value="editableData[record.key].productId"
                              show-search
                              :placeholder="$t('i18nCommon.Product')"
                              style="width: 100%"
                              :options="ProductFilters"
                              :filterOption="false"
                              @focus="loadDataProduct"
                              @change="onChangeProduct(record.key)"
                              @search="filterDataProduct"
                              :field-names="{
                                label: `productName`,
                                value: `id`,
                              }"
                            ></a-select>
                          </div>
                          <div v-else>
                            <span>{{ record.productName }}</span>
                          </div>
                        </div>
                      </template>
                      <template #quantity="{ record }">
                        <div class="editable-cell">
                          <div
                            v-if="editableData[record.key]"
                            class="editable-cell-input-wrapper"
                          >
                            <a-input-number
                              class="w-full"
                              v-model:value="editableData[record.key].quantity"
                              @change="onChangeQuantity(record.key)"
                            ></a-input-number>
                          </div>
                          <div v-else>
                            <span>{{ record.quantity }}</span>
                          </div>
                        </div>
                      </template>
                      <template #operation="{ record }">
                        <div class="flex">
                          <div
                            v-if="editableData[record.key]"
                            class="mr-4 icon-24 icon-check-outline cursor-pointer"
                            :title="$t('i18nCommon.SaveRow')"
                            @click="saveRow(record.key)"
                          ></div>
                          <div
                            v-else
                            :title="$t('i18nCommon.EditRow')"
                            class="icon-24 icon-edit mr-4 cursor-pointer"
                            @click="editRow(record.key)"
                          ></div>
                          <a-popconfirm
                            v-if="dataSource.length"
                            :title="$t('i18nCommon.AreYouSureDelete')"
                            @confirm="deleteRow(record)"
                            :okText="$t('i18nCommon.Yes')"
                            :cancelText="$t('i18nCommon.No')"
                          >
                            <div
                              class="icon-24 icon-delete cursor-pointer"
                              :title="$t('i18nCommon.DeleteRow')"
                            ></div>
                          </a-popconfirm>

                          <div
                            :title="$t('i18nCommon.OverQuantity')"
                            v-if="
                              editableData[record.key] &&
                              editableData[record.key].overQuantity
                            "
                            class="icon-24 icon-warning ml-4"
                          ></div>
                        </div>
                      </template>
                    </a-table>
                  </div>
                </div>
              </a-form-item>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && order">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Order") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form ref="ruleFormRef" label-width="120px" class="demo-ruleForm">
              <div class="flex columns-2">
                <a-form-item
                  prop="id"
                  testek="id"
                  class="w-full flex-1 mr-8"
                  labelAlign="left"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">ID</div>
                    <a-input v-model:value="order.id" />
                  </div>
                </a-form-item>
                <a-form-item
                  prop="id"
                  testek="id"
                  class="w-full flex-1"
                  labelAlign="left"
                >
                  <div class="flex">
                    <div class="flex-1 font-bold text-xl">
                      {{ $t("i18nCommon.TotalAmount") }}
                    </div>
                    <div class="flex-1 font-bold text-xl">
                      {{ $filters.formatMoney(order.amount) }}
                      <span class="ml-2">VND</span>
                    </div>
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="shipPhone" testek="shipPhone" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.ShipPhone") }}
                    </div>
                    <a-input v-model:value="order.shippingPhoneNum" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="shipAddress" testek="shipAddress" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.ShipAddress") }}
                    </div>
                    <a-input v-model:value="order.shippingAddress" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item
                  prop="invoiceAddress"
                  testek="Same with shipping address"
                  class="w-full"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.InvoiceAddress") }}
                    </div>
                    <a-input v-model:value="order.invoiceAddress" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item v-if="order.orderItems && order.orderItems.length">
                <div>
                  <div class="table-items">
                    <a-table
                      bordered
                      :data-source="order.orderItems"
                      :columns="columnViews"
                      :pagination="false"
                      :scroll="{ y: '250px' }"
                    >
                      <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'name'">
                          <div class="name-text">
                            {{ record[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'supplierObject' &&
                            record.supplier
                          "
                        >
                          <div class="name-text">
                            {{ record.supplier[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'productObject' &&
                            record.product
                          "
                        >
                          <div class="name-text">
                            {{ record.product[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'categoryObject' &&
                            record.category
                          "
                        >
                          <div class="name-text">
                            {{ record.category[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="record && column.dataIndex === 'status' && record.status"
                        >
                          <span>
                            <a-tag
                              :color="
                                record &&
                                record.status &&
                                (record.status.toUpperCase() === 'INACTIVE' ||
                                  record.status.toUpperCase() === 'CANCELLED')
                                  ? 'volcano'
                                  : 'green'
                              "
                            >
                              {{ record.status.toUpperCase() }}
                            </a-tag>
                          </span>
                        </template>
                      </template>
                    </a-table>
                  </div>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { ModuleOrder, ModuleProduct } from "@/store/module-const";
import BaseDetail from "@/views/base/BaseDetail.vue";
import { CheckOutlined, EditOutlined } from "@ant-design/icons-vue";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "ItemDetail",
  components: {
    BaseDetail,
    CheckOutlined,
    EditOutlined,
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      columns: [],
      currentItem: {},
      dataSource: [],
      editableData: {},
      columnViews: [],
      order: {},
      isShow: false,
    };
  },
  computed: {
    ...mapGetters(ModuleProduct, ["Products"]),
    title() {
      return this.$t("i18nCommon.AddItem");
    },
    TotalAmount() {
      //tổng tiền trong các dòng
      return this.dataSource.reduce((total, item) => total + item.total, 0);
    },
    ProductFilters() {
      const me = this;
      //Loại bỏ các product đã chọn trong các dòng đã chọn(trong editableData)
      let products = me.Products;
      if (me.editableData) {
        let productIds = Object.values(me.editableData).map((x) => x.productId);
        products = products.filter((x) => !productIds.includes(x.id));
      }
      return products;
    },
  },
  created() {
    const me = this;
    me.initDataStatic();
  },
  methods: {
    ...mapActions(ModuleProduct, ["getProductList"]),
    ...mapActions(ModuleOrder, ["createOrderItem", "getOrder"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        id: [
          {
            required: true,
            message: `${me.$t("i18nProduct.OrderIdInvalid")}`,
            trigger: "blur",
          },
        ],
      };
      me.columns = [
        {
          title: me.$t("i18nCommon.Product"),
          dataIndex: "productId",
          width: "25%",
          slots: {
            customRender: "product",
          },
        },
        {
          title: me.$t("i18nCommon.Quantity"),
          dataIndex: "quantity",
          width: "25%",
          slots: {
            customRender: "quantity",
          },
        },
        {
          title: me.$t("i18nCommon.Price"),
          dataIndex: "price",
        },
        {
          title: me.$t("i18nCommon.Total"),
          dataIndex: "total",
        },
        {
          title: "",
          dataIndex: "operation",
          slots: {
            customRender: "operation",
          },
        },
      ];

      me.columnViews = [
        {
          title: me.$t("i18nCommon.Product"),
          dataIndex: "productName",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nCommon.Quantity"),
          dataIndex: "quantity",
          width: "25%",
        },
        {
          title: me.$t("i18nCommon.Price"),
          dataIndex: "price",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nCommon.DiscountRate"),
          dataIndex: "discountRate",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nProduct.Status"),
          dataIndex: "status",
          width: 150,
          align: "center",
        },
      ];

      me.dataSource = [me.getDataRowDefault()];
    },

    //sử dụng debound
    submitForm: _.debounce(async function (isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;

      formEl
        .validate()
        .then(() => {
          //Check xem có dòng nào chưa lưu dòng hay không trong editableData
          if (Object.keys(me.editableData).length > 0) {
            this.$messageNotification.openNotificationWithIcon(
              "warning",
              this.$t("i18nCommon.Warning"),
              me.$t("i18nCommon.SaveRowBeforeSubmit"),
              3,
              "top"
            );
            return;
          }

          //Loại bỏ các dữ liệu trống
          let dataSource = me.dataSource.filter((x) => x.productId);
          //Kiểm tra xem có dòng nào vượt quá số lượng hay không
          let overQuantity = dataSource.find((x) => x.overQuantity);
          if (overQuantity) {
            this.$messageNotification.openNotificationWithIcon(
              "warning",
              this.$t("i18nCommon.Warning"),
              me.$t("i18nCommon.SaveRowBeforeSubmit"),
              3,
              "top"
            );
            return;
          }

          if (
            !me.dataSource ||
            me.dataSource.length <= 0 ||
            me.dataSource.filter((x) => x.quantity).length <= 0
          ) {
            this.$messageNotification.openNotificationWithIcon(
              "warning",
              this.$t("i18nCommon.Warning"),
              me.$t("i18nCommon.NotRowSave"),
              3,
              "top"
            );
            return;
          }

          dataSource = dataSource
            .filter((x) => x.quantity)
            .map((x) => {
              return {
                discountRate: 0,
                orderId: me.ruleForm.id,
                productId: x.productId,
                quantity: x.quantity,
                variant: "",
              };
            });
          me.addData(dataSource, isReset);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }, 500),

    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),

    addData: _.debounce(async function (lstData, isReset = true) {
      const me = this;
      let result = await me.createOrderItem(lstData);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(me.$t("i18nCommon.AddItemSuccess"));
        if (isReset == true) {
          me.ruleForm = {};
          me.dataSource = [this.getDataRowDefault()];
        }
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("createItemOrder.AddItemFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.order = await me.getOrder({ id: params.id });
      if (me.order) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),
    getDataRowDefault() {
      const me = this;
      return {
        productId: "",
        quantity: null,
        price: null,
        total: null,
        key: me.$commonFunc.generateUUID(),
      };
    },
    handleAddRow() {
      if (this.dataSource.length > this.$config.MaxRowItems) {
        this.$messageNotification.openNotificationWithIcon(
          "warning",
          this.$t("i18nCommon.Warning"),
          this.$t("i18nCommon.MaxRowItems"),
          3,
          "top"
        );
        return;
      }
      const newData = this.getDataRowDefault();
      this.dataSource.push(newData);
    },

    editRow(key) {
      const me = this;
      me.editableData[key] = _.cloneDeep(
        me.dataSource.filter((item) => key === item.key)[0]
      );
    },
    saveRow(key) {
      const me = this;
      if (!me.editableData[key] || me.editableData[key].overQuantity) {
        this.$messageNotification.openNotificationWithIcon(
          "warning",
          this.$t("i18nCommon.Warning"),
          this.$t("i18nCommon.QuantityRowOver"),
          3,
          "top"
        );
        return;
      }

      Object.assign(
        me.dataSource.filter((item) => key === item.key)[0],
        me.editableData[key]
      );
      delete me.editableData[key];
    },

    deleteRow(record) {
      const me = this;
      //K được xóa dòng đầu tiên
      if (me.dataSource.length === 1) {
        this.$messageNotification.openNotificationWithIcon(
          "warning",
          this.$t("i18nCommon.Warning"),
          this.$t("i18nCommon.MinRowItems"),
          3,
          "top"
        );
        return;
      }

      me.dataSource = me.dataSource.filter((item) => item.key !== record.key);
    },

    loadDataProduct: _.debounce(async function () {
      const me = this;
      if (me.Products && me.Products.length > 0) return;
      await me.getProductList();
    }, 300),

    filterDataProduct: _.debounce(async function (searchText) {
      const me = this;
      await me.getProductList({
        keyword: searchText,
      });
    }, 500),

    onChangeProduct: _.debounce(function (payload) {
      const me = this;
      let editableData = me.editableData[payload];
      if (editableData) {
        let product = me.Products.find((x) => x.id == editableData.productId);
        if (product) {
          editableData.price = product.price;
          editableData.productName = product.productName;
          if (editableData.quantity) {
            editableData.overQuantity = editableData.quantity > product.quantity;
            editableData.total = editableData.price * editableData.quantity;
          }
        }
      }
      // let supplier = me.Suppliers.find((x) => x.id == payload);
      // if (supplier) {
      //   me.ruleForm.supplier = supplier.id;
      // }
    }, 500),

    onChangeQuantity: _.debounce(function (payload) {
      const me = this;
      let editableData = me.editableData[payload];
      if (editableData) {
        if (editableData.quantity) {
          editableData.total = editableData.price * editableData.quantity;
          let product = me.Products.find((x) => x.id == editableData.productId);
          if (product) {
            editableData.overQuantity = editableData.quantity > product.quantity;
          }
        }
      }
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}

.editable-cell {
  position: relative;

  .editable-cell-input-wrapper,
  .editable-cell-text-wrapper {
    padding-right: 24px;
  }

  .editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
  }

  .editable-cell-icon,
  .editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
  }

  .editable-cell-icon {
    margin-top: 4px;
    display: none;
  }

  .editable-cell-icon-check {
    line-height: 28px;
  }

  .editable-cell-icon:hover,
  .editable-cell-icon-check:hover {
    color: #108ee9;
  }

  .editable-add-btn {
    margin-bottom: 8px;
  }
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}
</style>
